<template>
  <CommonModalAutoHeight
    modalId="painCareInfoModal"
    :headerShow="false"
    @click-backdrop="closePainCareInfoModal"
  >
    <div class="care__container" slot="body">
      <div class="care__header">
        <p class="header__title">지원 자격 안내</p>
        <button
          type="button"
          class="header__close"
          aria-label="닫기"
          @click="closePainCareInfoModal"
        />
      </div>
      <p class="care__subtitle">
        아래 자격 요건 중 <strong>최소 1개 이상</strong>에 해당해야 지원할 수
        있어요.
      </p>
      <ul class="care__qualifications">
        <li>
          <strong>면허 소지자</strong>
          <span>물리치료사 또는 작업치료사 면허 소지</span>
        </li>
        <li>
          <strong>관련 전공자</strong>
          <span>스포츠의학 또는 스포츠의과학 전공 등 관련 학과 학위</span>
        </li>
        <li>
          <strong>인증 자격 보유자</strong>
          <span
            >KACEP(대한운동사협회) 또는 NASM(미국스포츠의학회) 자격 보유</span
          >
        </li>
      </ul>
      <p class="care__notice">
        ⚠️ 일반 운동 자격이나 민간 재활 교육 수료증만으로는 해당하지 않아요.
        서류 제출 시 증빙이 꼭 필요해요.
      </p>
      <p class="care__question">
        위 자격 요건 중 최소 1개 이상에 해당하시나요?
      </p>
      <div class="care__buttons">
        <button type="button" class="care__button" @click="clickOk">
          예, 해당해요
        </button>
        <button
          type="button"
          class="care__button care__button--secondary"
          @click="clickNo"
        >
          아니요, 해당하지 않아요
        </button>
      </div>
    </div>
  </CommonModalAutoHeight>
</template>
<script>
import CommonModalAutoHeight from '@/components/common/CommonModalAutoHeight'
export default {
  name: 'PainCareInfoModal',
  components: {
    CommonModalAutoHeight
  },
  methods: {
    closePainCareInfoModal() {
      this.$emit('close-pain-care-info-modal')
    },
    clickOk() {
      this.$emit('click-ok')
    },
    clickNo() {
      this.$emit('click-no')
      this.closePainCareInfoModal()
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/_index.scss';
.care__container {
  padding: 0 24px 24px;
  color: #333333;
}
.care__header {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header__title {
    font-size: 20px;
    font-weight: $medium;
  }
  .header__close {
    flex: 0 0 24px;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    background: url(https://dcse8twossp9.cloudfront.net/static/img/icon/close-black-24-px.svg)
      center no-repeat;
    cursor: pointer;
  }
}
.care__subtitle {
  font-size: 15px;
  line-height: 22px;
  color: #555555;
  word-break: keep-all;
  strong {
    color: #000000;
    font-weight: $bold;
  }
}
.care__qualifications {
  padding: 0;
  margin: 24px 0;
  list-style: none;
  li {
    position: relative;
    padding-bottom: 36px;
    &::after {
      content: '또는';
      position: absolute;
      bottom: 10px;
      left: 0;
      font-size: 13px;
      line-height: 18px;
      color: #999999;
    }
    &:last-child {
      padding-bottom: 0;
      &::after {
        content: none;
      }
    }
    span {
      word-break: keep-all;
    }
  }
  strong,
  span {
    display: block;
  }
  strong {
    margin-bottom: 4px;
    font-size: 15px;
    line-height: 22px;
    font-weight: $bold;
  }
  span {
    font-size: 14px;
    line-height: 21px;
    color: #555555;
  }
}
.care__notice {
  padding: 12px 16px;
  border-radius: 8px;
  background-color: #fbeedc;
  font-size: 13px;
  line-height: 19px;
  color: #c29151;
  word-break: keep-all;
}
.care__question {
  font-size: 15px;
  line-height: 22px;
  margin: 24px 0 12px;
  font-weight: $bold;
}
.care__buttons {
  display: flex;
  flex-direction: column;
}
.care__button {
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  border: 1px solid #000000;
  background-color: #000000;
  color: #ffffff;
  font-size: 15px;
  font-family: inherit;
  font-weight: $bold;
  cursor: pointer;
  & + .care__button {
    margin-top: 8px;
  }
  &--secondary {
    border-color: #e1e1e1;
    background-color: #ffffff;
    color: #555555;
  }
}
</style>
